import type { Theme } from '@mui/material';

export const sxList = (theme: Theme, darkMode = false) => ({
  display: 'flex',
  flexGrow: '1',
  px: 2.5,
  m: 0,
  '& .customScrollBar': {
    '&::-webkit-scrollbar': {
      width: '6px',
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: darkMode ? theme.palette.grey[800] : theme.palette.common.white,
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[darkMode ? 700 : 400],
      borderRadius: '12px',
    },
  },
  minHeight: '150px',
});

export const sxAvatar = (theme: Theme) => ({
  bgcolor: theme.palette.grey[700],
  textTransform: 'uppercase',
  color: theme.palette.grey[500],
});

export const sxItemAvatar = {
  position: 'relative',
};

export const sxCheckOutIcon = {
  color: 'primary.main',
};

export const sxItemButton = (selected: boolean, isNoBackground: boolean, theme: Theme) => ({
  borderRadius: 2,
  p: 1,
  bgcolor: selected && !isNoBackground ? theme.palette.action.hover : 'transparent',
  display: 'flex',
  justifyContent: 'space-between',
});

export const sxSelectedBox = {
  position: 'absolute',
  top: '0',
  left: '0',
  bottom: '0',
  right: 0,
  zIndex: 2,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  bgcolor: 'rgba(0, 0, 0, .5)',
};

export const sxLocationBox = { flex: '0 0 auto', maxWidth: '40%', ml: 1, display: 'flex', alignItems: 'center' };
